<div class="is-flex is-column gap-24">

  <section class="is-flex">
    <app-radio-button-group size="small" inline>
      <app-radio-button-item (click)="selectedTab.set(ForecastTabs.DAY)"
        [selected]="selectedTab() === ForecastTabs.DAY" ga-event="ForecastDay">
        <app-radio-button-label [text]="'legrand-app.__LEG_DAY' | LANG"></app-radio-button-label>
      </app-radio-button-item>
      <app-radio-button-item (click)="selectedTab.set(ForecastTabs.WEEK)"
        [selected]="selectedTab() === ForecastTabs.WEEK" ga-event="ForecastWeek">
        <app-radio-button-label [text]="'legrand-app.__LEG_WEEK' | LANG"></app-radio-button-label>
      </app-radio-button-item>
      <app-radio-button-item (click)="selectedTab.set(ForecastTabs.TEMPERATURE)"
        [selected]="selectedTab() === ForecastTabs.TEMPERATURE" ga-event="ForecastTemperature">
        <app-radio-button-label [text]="'common-app.__TEMPERATURE' | LANG"></app-radio-button-label>
      </app-radio-button-item>
      <app-radio-button-item (click)="selectedTab.set(ForecastTabs.RAIN)"
        [selected]="selectedTab() === ForecastTabs.RAIN" ga-event="ForecastRain">
        <app-radio-button-label [text]="'common-app.__RAIN' | LANG"></app-radio-button-label>
      </app-radio-button-item>
      <app-radio-button-item (click)="selectedTab.set(ForecastTabs.WIND)"
        [selected]="selectedTab() === ForecastTabs.WIND" ga-event="ForecastWind">
        <app-radio-button-label [text]="'common-app.__WIND' | LANG"></app-radio-button-label>
      </app-radio-button-item>
    </app-radio-button-group>
  </section>

  <div class="is-relative" [@animateTab]="selectedTab()">
    <app-cp-forecast-tab-today *ngIf="selectedTab() === ForecastTabs.DAY"></app-cp-forecast-tab-today>
    <app-cp-forecast-tab-week *ngIf="selectedTab() === ForecastTabs.WEEK"></app-cp-forecast-tab-week>
    <app-cp-forecast-tab-temperature *ngIf="selectedTab() === ForecastTabs.TEMPERATURE"></app-cp-forecast-tab-temperature>
    <app-cp-forecast-tab-rain *ngIf="selectedTab() === ForecastTabs.RAIN"></app-cp-forecast-tab-rain>
    <app-cp-forecast-tab-wind *ngIf="selectedTab() === ForecastTabs.WIND"></app-cp-forecast-tab-wind>
  </div>

</div>